/** localStorage 键名集中管理（避免魔法字符串散落）。 */
export const TOKEN_KEY = 'career.token'
export const ROLE_KEY = 'career.role'
